import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('a-card', [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', [_vm._v("拟稿")]), _c('a-space', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a-button', {
    on: {
      "click": _vm.backPage
    }
  }, [_vm._v("返回")]), _vm.mode === 'add' ? _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 存为草稿 ")]) : _vm._e(), _vm.mode === 'edit' ? _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editSubmit
    }
  }, [_vm._v(" 存为草稿 ")]) : _vm._e(), _vm.mode === 'add' ? _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitAndAudit
    }
  }, [_vm._v(" 提交 ")]) : _vm._e(), _vm.mode === 'edit' ? _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editAndAudit
    }
  }, [_vm._v(" 提交 ")]) : _vm._e()], 1)], 1)]), _c('a-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-card', {
    staticClass: "body-content",
    attrs: {
      "size": "small"
    }
  }, [_vm.form.tempId == 1 ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules1
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "文件编号",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "fileCode"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "maxLength": 20
    },
    model: {
      value: _vm.form.fileCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fileCode", $$v);
      },
      expression: "form.fileCode"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "缓急",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "urgency"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "maxLength": 20
    },
    model: {
      value: _vm.form.urgency,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "urgency", $$v);
      },
      expression: "form.urgency"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "密级",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "secretLevel"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "maxLength": 20
    },
    model: {
      value: _vm.form.secretLevel,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "secretLevel", $$v);
      },
      expression: "form.secretLevel"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "文件名称",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "fileName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "disabled": _vm.mode == 'view',
      "maxLength": 50
    },
    model: {
      value: _vm.form.fileName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fileName", $$v);
      },
      expression: "form.fileName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      }
    }
  }, [_c('a-cascader', {
    ref: "currOrganCascader",
    style: {
      width: '100%'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.form.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "organPostId", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.organPostId"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "主送",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "mainDelivery"
    }
  }, [_c('select-person', {
    ref: "personPick",
    class: _vm.mode == 'edit' ? '' : 'disabled-content',
    attrs: {
      "businessId": 1,
      "width": "100%",
      "height": "9.375rem"
    },
    model: {
      value: _vm.form.mainDelivery,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mainDelivery", $$v);
      },
      expression: "form.mainDelivery"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "抄送",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "copyDelivery"
    }
  }, [_c('select-person', {
    ref: "personPick",
    class: _vm.mode == 'edit' ? '' : 'disabled-content',
    attrs: {
      "businessId": 1,
      "width": "100%",
      "height": "9.375rem"
    },
    model: {
      value: _vm.form.copyDelivery,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "copyDelivery", $$v);
      },
      expression: "form.copyDelivery"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "附件",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "fileList"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": true,
      "file-list": _vm.form.fileList,
      "headers": _vm.headers,
      "action": "api/docSendMgr/uploadAttach",
      "disabled": _vm.mode == 'view'
    },
    on: {
      "change": _vm.handleChangeUpload,
      "preview": _vm.handlePreview
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "inbox"
    }
  }, [_vm._v("点击上传附件")])], 1)], 1)], 1) : _vm._e(), _vm.form.tempId == 2 ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules1
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "文件编号",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "fileCode"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "maxLength": 20
    },
    model: {
      value: _vm.form.fileCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fileCode", $$v);
      },
      expression: "form.fileCode"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "缓急",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "urgency"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "maxLength": 20
    },
    model: {
      value: _vm.form.urgency,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "urgency", $$v);
      },
      expression: "form.urgency"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "密级",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "secretLevel"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "maxLength": 20
    },
    model: {
      value: _vm.form.secretLevel,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "secretLevel", $$v);
      },
      expression: "form.secretLevel"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "文件名称",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "fileName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "disabled": _vm.mode == 'view',
      "maxLength": 50
    },
    model: {
      value: _vm.form.fileName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fileName", $$v);
      },
      expression: "form.fileName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      }
    }
  }, [_c('a-cascader', {
    ref: "currOrganCascader",
    style: {
      width: '100%'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.form.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "organPostId", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.organPostId"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "主送",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "mainDelivery"
    }
  }, [_c('select-person', {
    ref: "personPick",
    class: _vm.mode == 'edit' ? '' : 'disabled-content',
    attrs: {
      "businessId": 1,
      "width": "100%",
      "height": "9.375rem"
    },
    model: {
      value: _vm.form.mainDelivery,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mainDelivery", $$v);
      },
      expression: "form.mainDelivery"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "抄送",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "copyDelivery"
    }
  }, [_c('select-person', {
    ref: "personPick",
    class: _vm.mode == 'edit' ? '' : 'disabled-content',
    attrs: {
      "businessId": 1,
      "width": "100%",
      "height": "9.375rem"
    },
    model: {
      value: _vm.form.copyDelivery,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "copyDelivery", $$v);
      },
      expression: "form.copyDelivery"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "附件",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "fileList"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": true,
      "file-list": _vm.form.fileList,
      "headers": _vm.headers,
      "action": "api/docSendMgr/uploadAttach",
      "disabled": _vm.mode == 'view'
    },
    on: {
      "change": _vm.handleChangeUpload,
      "preview": _vm.handlePreview
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "inbox"
    }
  }, [_vm._v("点击上传附件")])], 1)], 1)], 1) : _vm._e(), _vm.form.tempId == 3 ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules2
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "文件编号",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "fileCode",
      "maxLength": 20
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": ""
    },
    model: {
      value: _vm.form.fileCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fileCode", $$v);
      },
      expression: "form.fileCode"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "标题",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "fileName"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "maxLength": 200,
      "disabled": _vm.mode == 'view'
    },
    model: {
      value: _vm.form.fileName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fileName", $$v);
      },
      expression: "form.fileName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "日期",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "formDate",
      "maxLength": 20
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.form.formDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "formDate", $$v);
      },
      expression: "form.formDate"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      }
    }
  }, [_c('a-cascader', {
    ref: "currOrganCascader",
    style: {
      width: '100%'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.form.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "organPostId", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.organPostId"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "抄送",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "copyDelivery"
    }
  }, [_c('select-person', {
    ref: "personPick",
    class: _vm.mode == 'edit' ? '' : 'disabled-content',
    attrs: {
      "businessId": 1,
      "width": "100%",
      "height": "9.375rem"
    },
    model: {
      value: _vm.form.copyDelivery,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "copyDelivery", $$v);
      },
      expression: "form.copyDelivery"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "附件",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "fileList"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": true,
      "file-list": _vm.form.fileList,
      "headers": _vm.headers,
      "action": "api/docSendMgr/uploadAttach",
      "disabled": _vm.mode == 'view'
    },
    on: {
      "change": _vm.handleChangeUpload,
      "preview": _vm.handlePreview
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "inbox"
    }
  }, [_vm._v("点击上传附件")])], 1)], 1)], 1) : _vm._e(), _vm.form.tempId == 4 ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules2
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "公文标题",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "fileName"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "maxLength": 200
    },
    model: {
      value: _vm.form.fileName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fileName", $$v);
      },
      expression: "form.fileName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "公文文号",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "fileCode"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "maxLength": 20,
      "placeholder": ""
    },
    model: {
      value: _vm.form.fileCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fileCode", $$v);
      },
      expression: "form.fileCode"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "紧急文件",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "isEmergent"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.form.isEmergent,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isEmergent", $$v);
      },
      expression: "form.isEmergent"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      }
    }
  }, [_c('a-cascader', {
    ref: "currOrganCascader",
    style: {
      width: '100%'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.form.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "organPostId", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.organPostId"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "发布范围",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "copyDelivery"
    }
  }, [_c('select-person', {
    ref: "personPick",
    class: _vm.mode == 'edit' ? '' : 'disabled-content',
    attrs: {
      "businessId": 1,
      "width": "100%",
      "height": "9.375rem"
    },
    model: {
      value: _vm.form.copyDelivery,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "copyDelivery", $$v);
      },
      expression: "form.copyDelivery"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "附件",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "fileList"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": true,
      "file-list": _vm.form.fileList,
      "headers": _vm.headers,
      "action": "api/docSendMgr/uploadAttach",
      "disabled": _vm.mode == 'view'
    },
    on: {
      "change": _vm.handleChangeUpload,
      "preview": _vm.handlePreview
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "inbox"
    }
  }, [_vm._v("点击上传附件")])], 1)], 1)], 1) : _vm._e()], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-card', {
    staticClass: "body-content",
    attrs: {
      "size": "small"
    }
  }, [_vm.form.tempId == 1 ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("绵阳中学英才学校纪委办拟文稿")]), _c('a-row', {
    staticStyle: {
      "margin-top": "0.625rem"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-left"
  }, [_c('div', [_vm._v(" 文件编号： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.fileCode))])])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 缓急： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.urgency) + " ")])])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 密级： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.secretLevel) + " ")])])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left double-height"
  }, [_c('div', [_vm._v("文件名称：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.fileName))])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right double-height"
  }, [_c('div', [_vm._v("附件：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.fileNameGroup.join(', ')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left triple-height-x2"
  }, [_c('div', [_vm._v("签发：")]), _c('div', [_vm._v(_vm._s(_vm.form.qfyj))]), _c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "sign-content"
  }, [_c('span', [_vm._v("纪委书记（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "5.625rem"
    }
  }, [_vm._v("日期：")])])])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right triple-second-height-x2"
  }, [_c('div', [_vm._v("初核：")]), _c('div', [_vm._v(_vm._s(_vm.form.chyj))]), _c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "sign-content"
  }, [_c('span', [_vm._v("纪委办主任（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "3.625rem"
    }
  }, [_vm._v("日期：")])])])]), _c('div', {
    staticClass: "form-content-content-right triple-second-height"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "margin-top:1.5rem"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("拟稿：")]), _c('span', [_vm._v("拟稿人（签字）:")]), _c('br'), _c('span', {
    staticStyle: {
      "margin-top": "0.825rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.createTime) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.signImgUrl !== '' && _vm.form.signImgUrl != undefined ? _c('img', {
    staticStyle: {
      "width": "4.95rem",
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.signImgUrl,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("主送")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.zsNameList.join(',')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("抄送：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.csNameList.join(',')) + " ")])])])], 1)], 1) : _vm._e(), _vm.form.tempId == 2 ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("中共绵阳中学英才学校委员会拟文稿")]), _c('a-row', {
    staticStyle: {
      "margin-top": "0.625rem"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-left"
  }, [_c('div', [_vm._v(" 文件编号： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.fileCode))])])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 缓急： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.urgency) + " ")])])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 密级： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.secretLevel) + " ")])])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left double-height"
  }, [_c('div', [_vm._v("文件名称：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.fileName))])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right double-height"
  }, [_c('div', [_vm._v("附件：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.fileNameGroup.join(', ')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left triple-height-x2"
  }, [_c('div', [_vm._v("签发：")]), _c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "sign-content"
  }, [_c('span', [_vm._v("党委书记（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "5.625rem"
    }
  }, [_vm._v("日期：")])])])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right triple-first-height"
  }, [_c('div', [_vm._v("复核：")]), _c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "sign-content-fuhe"
  }, [_c('span', [_vm._v("专职副书记（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "1.625rem"
    }
  }, [_vm._v("日期：")])])])]), _c('div', {
    staticClass: "form-content-content-right triple-second-height"
  }, [_c('div', [_vm._v("初核：")]), _c('div', {
    staticClass: "content-font"
  })]), _c('div', {
    staticClass: "form-content-content-right triple-second-height"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "margin-top:1.5rem"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("拟稿：")]), _c('span', [_vm._v("拟稿人（签字）:")]), _c('br'), _c('span', {
    staticStyle: {
      "margin-top": "0.825rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.createTime) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.signImgUrl !== '' && _vm.form.signImgUrl != undefined ? _c('img', {
    staticStyle: {
      "width": "4.95rem",
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.signImgUrl,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("会签：")]), _c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("主送：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.zsNameList.join(',')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("抄送：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.csNameList.join(',')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-left"
  }, [_c('div', [_vm._v("打印：")])])]), _c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  })]), _c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  }, [_c('div', [_vm._v("校对：")])])]), _c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  })]), _c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  }, [_c('div', [_vm._v("份数：")])])]), _c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  })])], 1)], 1) : _vm._e(), _vm.form.tempId == 3 ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("绵阳中学英才学校发文审批单")]), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form2-content-top-left"
  }, [_c('div', [_vm._v(" 理事长签发： "), _c('span', {
    staticClass: "content-font"
  })])])]), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "form2-content-top-right-top"
  }, [_vm._v("拟稿部门")]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_vm._v("审稿部门")]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_vm._v("分管校级领导审核")]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_vm._v("会签")])]), _c('a-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "form2-content-top-right-top"
  }, [_c('span', {
    staticClass: "content-font"
  })]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_c('span', {
    staticClass: "content-font"
  })]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_c('span', {
    staticClass: "content-font"
  })]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_c('span', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left"
  }, [_c('div', [_vm._v("日期")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.formDate))])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left double-height"
  }, [_c('div', [_vm._v("标题")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right double-height"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.fileName) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left triple-height"
  }, [_c('div', [_vm._v("抄送")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right triple-height"
  }, [_c('div', {
    staticClass: "content-font triple-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.csNameList.join(',')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left triple-height"
  }, [_c('div', [_vm._v("附件")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right triple-height"
  }, [_c('div', {
    staticClass: "content-font triple-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.fileNameGroup.join(', ')) + " ")])])])], 1)], 1) : _vm._e(), _vm.form.tempId == 4 ? _c('div', [_c('div', {
    staticClass: "form-title",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(" 绵阳中学英才学校公文处理笔笺 ")]), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.form.fileCode || ''))]), _c('a-row', [_c('a-col', {
    staticStyle: {
      "border-top": "1px solid red"
    },
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("公文标题")])])]), _c('a-col', {
    staticStyle: {
      "border-top": "1px solid red"
    },
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.fileName))])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("拟办意见")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_vm.form.docData ? _c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.proposedauditopinion || '') + " ")]) : _vm._e()])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("党委书记批示")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_vm.form.docData ? _c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.memorandumauditopinion || '') + " ")]) : _vm._e()])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("办理结果")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.result))])])])], 1)], 1) : _vm._e()])], 1)], 1), _c('a-modal', {
    attrs: {
      "visible": _vm.previewShow,
      "footer": null,
      "centered": true,
      "width": "80rem"
    },
    on: {
      "cancel": _vm.handleCancel
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(70vh)"
    },
    attrs: {
      "src": _vm.previewSrc,
      "seamless": ""
    }
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };